import { render, staticRenderFns } from "./SignInFormCpf.vue?vue&type=template&id=ac8474dc&scoped=true"
import script from "./SignInFormCpf.vue?vue&type=script&lang=js"
export * from "./SignInFormCpf.vue?vue&type=script&lang=js"
import style0 from "./SignInFormCpf.vue?vue&type=style&index=0&id=ac8474dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac8474dc",
  null
  
)

export default component.exports